/*
 * Copyright (c) Nexign, JSC, 2023-2024.
 */
/**
 * News images component
 *
 * @author Alexander Golshtein
 * @author Evgeniy Naumov
 * @author Ilya Baranchikov
 * @version 1.28.0
 * @since 1.25.0
 */

import { FC } from 'react';

// TODO remove this lib and replace with images (banners) component from ui-kit
import Carousel from 'react-multi-carousel';

import { NewsImagesItem, NewsImagesWrapper } from '../styled/NewsImagesStyled';
import { INewsItemImage } from '../types';
import NewsImagesButtonGroup from './NewsImagesButtonGroup';
import NewsImagesDots from './NewsImagesDots';

const responsive = {
    superLargeDesktop: {
        breakpoint: { max: 4000, min: 3000 },
        items: 1,
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 1,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
    },
};

interface INewsImagesProps {
    images: INewsItemImage[];
}

const NewsImages: FC<INewsImagesProps> = ({ images }) => {
    if (!images.length) return null;

    return (
        <NewsImagesWrapper>
            <Carousel
                renderButtonGroupOutside
                renderDotsOutside
                arrows={false}
                autoPlay={false}
                customButtonGroup={images.length > 1 ? <NewsImagesButtonGroup /> : null}
                customDot={<NewsImagesDots />}
                draggable={images.length > 1}
                infinite={true}
                keyBoardControl={false}
                responsive={responsive}
                showDots={images.length > 1}
                swipeable={images.length > 1}
            >
                {images.map((image) => (
                    <NewsImagesItem draggable={false} key={image.id} src={image.link} />
                ))}
            </Carousel>
        </NewsImagesWrapper>
    );
};

export default NewsImages;
